// src/components/FileUpload.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Spinner } from "reactstrap";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

const FileUpload = ({
  formData,
  setFormData,
  inputKey,
  imageUrl,
  fieldName = "file",
  label = "Upload File",
  type = "image", // "image" | "pdf"
  folderName = "students_photos",
}) => {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [uploadStatus, setUploadStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {
      if (previewUrl && previewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  useEffect(() => {
    if (imageUrl) {
      setPreviewUrl(imageUrl);
      console.log("Image URL:", imageUrl);
    }
  }, [imageUrl]);
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setUploadStatus("");

    if (!selectedFile) {
      setUploadStatus("No file selected.");
      return;
    }

    const isPDF = selectedFile.type === "application/pdf";
    const isImage = selectedFile.type.startsWith("image/");

    if (type === "pdf" && !isPDF) {
      setUploadStatus("Only PDF files are allowed.");
      setFile(null);
      return;
    }

    if (type === "image" && !isImage) {
      setUploadStatus("Only image files are allowed.");
      setFile(null);
      return;
    }

    if (selectedFile.size > MAX_FILE_SIZE) {
      setUploadStatus("File size exceeds 2MB.");
      setFile(null);
      return;
    }

    setFile(selectedFile);
    if (selectedFile) {
      setPreviewUrl(URL.createObjectURL(selectedFile));
    } else {
      setPreviewUrl("");
    }
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a valid file.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_COLLEGE_ERP_API}get-upload-url`,
        {
          params: {
            fileName: file.name,
            folder: folderName,
            contentType: file.type,
          },
        }
      );

      const { uploadUrl, fileKey } = response.data;

      await axios.put(uploadUrl, file, {
        headers: { "Content-Type": file.type },
      });

      setFormData({
        ...formData,
        photoKey: fileKey,
      });

      alert("Upload successful!");
      setUploadStatus("");
    } catch (error) {
      console.error("Upload failed:", error);
      setUploadStatus("Upload failed. Try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const getAcceptTypes = () => {
    return type === "pdf" ? "application/pdf" : "image/*";
  };

  return (
    <div>
      {label} (Max: 2MB)
      <br />
      <input
        type="file"
        accept={getAcceptTypes()}
        onChange={handleFileChange}
        key={inputKey}
      />
      <button onClick={handleUpload} disabled={!file || isLoading}>
        {isLoading ? (
          <Spinner size="sm">
            <span></span>
          </Spinner>
        ) : (
          "Upload"
        )}
      </button>
      {uploadStatus && <p style={{ color: "red" }}>{uploadStatus}</p>}
      {previewUrl && (
        <div
          style={{
            marginTop: "10px",
            border: "1px solid #ccc",
            width: "100px",
          }}
        >
          <img
            src={previewUrl}
            alt="Preview"
            width="100"
            style={{
              border: "1px solid #ccc",
              display: "block",
              marginTop: "10px",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FileUpload;
